import { Box, BoxProps } from '@mui/material';
import { Fragment, memo } from 'react';
import jsonExport from 'jsonexport/dist';
import { BooleanField, BulkDeleteButton, BulkDeleteButtonProps, BulkExportButton, BulkExportButtonProps, Datagrid, DateField, downloadCSV, EditButton, List, ReferenceField, ShowButton, ShowView, SimpleShowLayout, TextField, TextInput } from 'react-admin';
import { LoginAsButton } from '../../Components/LoginAsButton';

const UsersListActionToolbar = (props: BoxProps) => <Box sx={{ alignItems: 'center', display: 'flex' }}>{props.children}</Box>;
const UsersListBulkActions = memo((props: BulkDeleteButtonProps & BulkExportButtonProps) => (
  <Fragment>
    <BulkDeleteButton {...props} />
    <BulkExportButton {...props} />
  </Fragment>
));
const exporter = (users: any[]) => {
  return jsonExport(users, (err: Error, csv: string) => downloadCSV(csv, 'users'));
};
const rowClick = (id: unknown, resource: unknown, record: any) => {
  if (record.commentable) {
    return 'edit';
  }
  return 'show';
};
const UsersPanel = () => {
  return (
    <ShowView>
      <SimpleShowLayout>
        <TextField source="id" />
        <TextField source="uuid" />
        <TextField source="fullName" />
        <BooleanField source="active" />
        <DateField source="birthDate" />
        <TextField source="sourcePlatform" />
        <TextField source="sourceType" />
        <DateField source="createdAt" sortByOrder="DESC" />
        <DateField source="updatedAt" sortByOrder="DESC" />
        <TextField source="taxPayerId" />
        <TextField source="sex" />
      </SimpleShowLayout>
    </ShowView>
  );
};

//const usersFilter = [<SearchInput source="fullName" alwaysOn />, <TextInput source="company" defaultValue="" />, <TextInput source="id" defaultValue="" />, <TextInput source="uuid" defaultValue="" />];
const usersFilter = [<TextInput label="User Name" source="fullName" alwaysOn />, <TextInput source="id" defaultValue="" alwaysOn />, <TextInput source="uuid" defaultValue="" alwaysOn />];

const UsersList: React.FC = () => {
  return (
    <List filters={usersFilter} sort={{ field: 'id', order: 'DESC' }} exporter={exporter}>
      <Datagrid bulkActionButtons={<UsersListBulkActions />} rowClick={rowClick} expand={UsersPanel} optimized sx={{ image: { maxHeight: '1rem' } }}>
        <TextField source="id" />
        <TextField source="uuid" />
        <TextField source="fullName" cellClassName="fullName" />
        <DateField source="createdAt" sortByOrder="DESC" cellClassName="createdAt" />
        <DateField source="updatedAt" sortByOrder="DESC" cellClassName="updatedAt" />
        <ReferenceField label="Email" source="userAccount" reference="user-accounts">
          <TextField source="email" />
        </ReferenceField>
        <ReferenceField label="Login As" source="userAccount" reference="user-accounts">
          <LoginAsButton userAccountIdSource="id" />
        </ReferenceField>
        <BooleanField source="active" sortable={false} />
        <UsersListActionToolbar>
          <EditButton />
          <ShowButton />
        </UsersListActionToolbar>
      </Datagrid>
    </List>
  );
};

export default UsersList;
